import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AngularFireAnalyticsModule } from '@angular/fire/analytics';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxAuthFirebaseUIModule } from 'ngx-auth-firebaseui';

export function firebaseAppNameFactory() {
  return `you_app_name`;
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebase, 'hias-43c0a'),
    AppRoutingModule,
    AngularFireAnalyticsModule, // dynamically imports firebase/analytics
    AngularFirestoreModule, // imports firebase/firestore, only needed for database features
    AngularFireAuthModule, // imports firebase/auth, only needed for auth features,
    AngularFireStorageModule, BrowserAnimationsModule, 
    NgxAuthFirebaseUIModule.forRoot(
                      {
                        apiKey: "AIzaSyC8pc7chQUImnf9iNS7QK6fhrlssUGnZBE",
                        authDomain: "hias-43c0a.firebaseapp.com",
                        databaseURL: "https://hias-43c0a.firebaseio.com",
                        projectId: "hias-43c0a",
                        storageBucket: "hias-43c0a.appspot.com",
                        messagingSenderId: "780905633548"
                      },
                        () => 'firebaseAppNameFactory()',
                      {
                        enableFirestoreSync: true, // enable/disable autosync users with firestore
                        toastMessageOnAuthSuccess: true, // whether to open/show a snackbar message on auth success - default : true
                        toastMessageOnAuthError: true, // whether to open/show a snackbar message on auth error - default : true
                        authGuardFallbackURL: '/loggedout', // url for unauthenticated users - to use in combination with canActivate feature on a route
                        authGuardLoggedInURL: '/loggedin', // url for authenticated users - to use in combination with canActivate feature on a route
                        passwordMaxLength: 60, // `min/max` input parameters in components should be within this range.
                        passwordMinLength: 8, // Password length min/max in forms independently of each componenet min/max.
                        // Same as password but for the name
                        nameMaxLength: 50,
                        nameMinLength: 2,
                        // If set, sign-in/up form is not available until email has been verified.
                        // Plus protected routes are still protected even though user is connected.
                        guardProtectedRoutesUntilEmailIsVerified: true,
                        enableEmailVerification: true, // default: true
                      }) // imports firebase/storage only needed for storage features
    
  ],
  
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }


